import { render } from "./a-close-button.vue?vue&type=template&id=96ab7ce2&scoped=true"
import script from "./a-close-button.vue?vue&type=script&lang=js"
export * from "./a-close-button.vue?vue&type=script&lang=js"

import "./a-close-button.vue?vue&type=style&index=0&id=96ab7ce2&scoped=true&lang=sass"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ab7ce2"]])

export default __exports__